export type ConfirmModalConfig = {
  title: string;
  description: string;
  action: {
    reject: string;
    accept: string;
  };
};
